import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'inbox-error',
  templateUrl: './inbox-error.component.html',
  styleUrls: ['./inbox-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [GalaxyEmptyStateModule, MatIcon, TranslateModule],
})
export class InboxErrorComponent {
  error = input.required<Error>();
  customErrorMessage = input<string | null>(null);
}
